const SOURCE_NOT_SELECTED = 'In some of the added attribute not selected "Data Type".';

export const eventDataTypeValidation = (attributeDataType: string): string[] => {
    const errorMassages = [];

    if (!attributeDataType) {
        errorMassages.push(SOURCE_NOT_SELECTED);
    }

    return errorMassages;
};
